import * as Types from "../../actions/constants";

const initialState = {
  vehicleData: {
    loading: false,
    error: false,
    success: false,
    rows: { data: [], meta: [] },
  },
  updateData: {
    loading: false,
    error: false,
    success: false,
    data: null,
  },
  createData: {
    loading: false,
    error: false,
    success: false,
    data: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_VEHICLE:
      return {
        ...state,
        vehicleData: {
          loading: true,
          error: false,
          success: false,
          rows: { data: [], meta: [] },
        },
      };
    case Types.VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleData: {
          loading: false,
          error: false,
          success: true,
          rows: action.response.data,
        },
      };
    case Types.VEHICLE_ERROR:
      return {
        ...state,
        vehicleData: {
          loading: false,
          error: true,
          success: false,
          rows: action.error.data.error,
        },
      };

    case Types.GET_VEHICLE_BY_ID:
      return {
        ...state,
        indexData: {
          loading: true,
          error: false,
          success: false,
          rows: { data: [], meta: [] },
        },
      };
    case Types.VEHICLE_BY_ID_SUCCESS:
      return {
        ...state,
        indexData: {
          loading: false,
          error: false,
          success: true,
          rows: action.response.data,
        },
      };
    case Types.VEHICLE_BY_ID_ERROR:
      return {
        ...state,
        indexData: {
          loading: false,
          error: true,
          success: false,
          rows: action.error.data.error,
        },
      };

    case Types.UPDATE_VEHICLE:
      return {
        ...state,
        updateData: {
          loading: true,
          error: false,
          success: false,
          data: null,
        },
      };
    case Types.UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        updateData: {
          loading: false,
          error: false,
          success: true,
          data: action.response,
        },
      };
    case Types.UPDATE_VEHICLE_ERROR:
      return {
        ...state,
        updateData: {
          loading: false,
          error: true,
          success: false,
          data: action.error.data.error,
        },
      };
    case Types.RESET_UPDATE_VEHICLE:
      return {
        ...state,
        updateData: {
          loading: false,
          error: false,
          success: false,
          data: null,
        },
      };

    case Types.UPDATE_VEHICLE_OWNERSHIP:
      return {
        ...state,
        updateData: {
          loading: true,
          error: false,
          success: false,
          data: null,
        },
      };
    case Types.UPDATE_VEHICLE_OWNERSHIP_SUCCESS:
      return {
        ...state,
        updateData: {
          loading: false,
          error: false,
          success: true,
          data: action.response,
        },
      };
    case Types.UPDATE_VEHICLE_OWNERSHIP_ERROR:
      return {
        ...state,
        updateData: {
          loading: false,
          error: true,
          success: false,
          data: action.error.data.error,
        },
      };
    case Types.RESET_UPDATE_VEHICLE_OWNERSHIP:
      return {
        ...state,
        updateData: {
          loading: false,
          error: false,
          success: false,
          data: null,
        },
      };

    case Types.CREATE_VEHICLE:
      return {
        ...state,
        createData: {
          loading: true,
          error: false,
          success: false,
          data: null,
        },
      };
    case Types.CREATE_VEHICLE_SUCCESS:
      return {
        ...state,
        createData: {
          loading: false,
          error: false,
          success: true,
          data: action.response,
        },
      };
    case Types.CREATE_VEHICLE_ERROR:
      return {
        ...state,
        createData: {
          loading: false,
          error: true,
          success: false,
          data: action.error.data.error,
        },
      };
    case Types.RESET_CREATE_VEHICLE:
      return {
        ...state,
        createData: {
          loading: false,
          error: false,
          success: false,
          data: null,
        },
      };

    default:
      return state;
  }
};
